<!-- A group or footer row on a grid the user groups (app-grid rowGrouping) has no value to show or tick. -->
@if (params.data || !params.context?.rowGrouping) {
  @if (isEditable) {
    <div class="d-flex align-items-center">
      <input type="checkbox" [checked]="params.value" (change)="onChange($event)" [disabled]="menuService.isReadOnly" />
    </div>
  } @else {
    <div>{{ params.value ? BooleanStrings.translatedYes : BooleanStrings.translatedNo }}</div>
  }
}
